export const formatPhoneNumber = (number) => {
  const cleaned = ("" + number).replace(/\D/g, "");
  let formatted = "";

  for (let i = 0; i < Math.min(cleaned.length, 10); i++) {
    if (i === 3 || i === 6) {
      formatted += "-";
    }
    formatted += cleaned[i];
  }

  return formatted;
};

export const formatPhoneNumberWithCountryCode = (phoneNumber) => {
  if (!phoneNumber) return "";

  const cleanedNumber = phoneNumber.replace(/\D/g, "");

  if (cleanedNumber.length === 10) {
    return `(${cleanedNumber.slice(0, 3)}) ${cleanedNumber.slice(3, 6)}-${cleanedNumber.slice(6)}`;
  }

  if (cleanedNumber.length === 11 && cleanedNumber.startsWith("1")) {
    const numberWithoutCountryCode = cleanedNumber.slice(1);
    return `(${numberWithoutCountryCode.slice(0, 3)}) ${numberWithoutCountryCode.slice(3, 6)}-${numberWithoutCountryCode.slice(6)}`;
  }

  return phoneNumber;
};
